<template>
  <div class="exam">
    <div class="nuv">
      <span>群培训管理&nbsp;&gt;</span>
      <span>{{ groupName }}</span>
    </div>
    <a href="javascript:;" class="top-button"><el-button type="primary">群考核名单</el-button></a>
    <el-form :inline="true">
      <el-form-item label="淘金客">
        <tjkautocomplete @callBack="updateTjkId"></tjkautocomplete>
      </el-form-item>
      <el-form-item label="合作公司">
        <providerautocomplete @callBack="updateProviderId"></providerautocomplete>
      </el-form-item>
      <el-form-item label="是否通过">
        <el-select v-model="passState" clearable placeholder="请选择">
          <el-option key="Passed" label="通过" value="Passed"></el-option>
          <el-option key="Failed" label="未通过" value="Failed"></el-option>
          <el-option key="NotExamine" label="未考" value="NotExamine"></el-option>
          <el-option key="Loss" label="流失" value="Loss"></el-option>
          <el-option key="Cancel" label="取消资格" value="Cancel"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="签到次数">
        <el-input v-model="checkInTimes"  clearable></el-input>
      </el-form-item>
      <el-form-item label="签到时间">
        <el-date-picker v-model="checkInStartTime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择开始日期" @change='changeHandlerStart'></el-date-picker>
        <el-date-picker v-model="checkInEndTime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择结束日期" @change='changeHandlerEnd'></el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="getList">查询</el-button>
        <el-button v-if="list.length>0" type="primary" @click="getExcel">导出</el-button>
        <el-button type="danger" @click="endOperatorExam">结束培训</el-button>
      </el-form-item>
    </el-form>
    <ul class="tab">
      <li v-for="(t, key) in examiningList" :class="{active: t.isCurrent}">
        <template v-if="t.isCurrent">
          <a :href="'/tjkStudy/enterExam?id='+t.operatorExamId+'&groupId='+groupId+'&groupName='+groupName" target="_blank">{{ t.operatorName }}&nbsp;&nbsp;考核人数：{{ t.examNum }}</a>
        </template>
        <template v-else>
          {{ t.operatorName }}&nbsp;&nbsp;考核人数：{{ t.examNum }}
        </template>
      </li>
    </ul>
    <p v-if="!success" class="tj-shift-notice">{{ message }}</p>
    <template v-else>
      <p class="tj-shift-notice" v-if="!list.length" style="padding-top: 45px;">暂无记录！</p>
      <template v-else>
        <el-table ref="multipleTable" border :data="list" tooltip-effect="dark" style="width: 100%;" @selection-change="handleSelectionChange">
          <el-table-column type="selection" align="center"></el-table-column>
          <el-table-column prop="realName" label="考核人员" align="center"></el-table-column>
          <el-table-column prop="loginName" label="电话" align="center"></el-table-column>
          <el-table-column prop="companyName" label="公司简称" align="center"></el-table-column>
          <el-table-column prop="checkInTimes" label="签到次数" align="center"></el-table-column>
          <el-table-column prop="tjkNumber" label="淘金号" align="center"></el-table-column>
          <el-table-column label="是否通过" align="center">
            <template slot-scope="scope">
              <el-select v-model="scope.row.passState" placeholder="请选择">
                <el-option key="Passed" label="通过" value="Passed"></el-option>
                <el-option key="Failed" label="未通过" value="Failed"></el-option>
                <el-option key="NotExamine" label="未考" value="NotExamine"></el-option>
                <el-option key="Loss" label="流失" value="Loss"></el-option>
                <el-option key="Cancel" label="取消资格" value="Cancel"></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="综合得分" align="center">
            <template slot-scope="scope">
              <el-input v-model.number="scope.row.score" placeholder="只能填写数字" clearable></el-input>
            </template>
          </el-table-column>
          <el-table-column label="备注" align="center">
            <template slot-scope="scope">
              <el-input type="textarea" autosize placeholder="不能超过200字" v-model="scope.row.remark" clearable></el-input>
            </template>
          </el-table-column>
        </el-table>
        <div class="tj-margin-top-xl">
          <el-button type="warning" @click="checkGroup">群考核</el-button>
          <el-button type="primary" @click="saveScore">保存打分</el-button>
          <el-button type="danger" @click="releaseGroup">发布成绩</el-button>
        </div>
      </template>
    </template>
    <!-- 群考核弹出层 -->
    <Modal ref="check">
      <div class="tj-table tj-fill tj-padding-right-xl">
        <dl>
          <dt class="tj-text-right"><font color="red">*</font> 外呼电话：</dt>
          <dd>
            <el-input placeholder="请输入内容" v-model.number="check.callPhone" clearable></el-input>
          </dd>
        </dl>
        <dl>
          <dt class="tj-text-right" style="width: 200px;"><font color="red">*</font> 平均外呼时长（分钟）：</dt>
          <dd>
            <el-input placeholder="请输入内容" v-model.number="check.averageDuration" clearable></el-input>
          </dd>
        </dl>
      </div>
    </Modal>
  </div>
</template>

<script>
export default {
  data() {
    return {
      success: true,
      message: '',
      groupId: this.$route.query.groupId,
      tjkId: '', //搜索的淘金客id
      providerId: '', //搜索的合作公司id
      passState: '', //通过状态
      checkInTimes: '', //签到次数
      checkInStartTime: '',
      checkInEndTime: '',
      multipleSelection: [],
      groupName: this.$route.query.groupName, //考核群名称
      list: [],
      examiningList: [],
      check: {
        callPhone: '',
        averageDuration: ''
      }
    }
  },
  mounted: function() {
    this.getList()
  },
  methods: {
    getList() {
      var data = {
        'groupId': this.groupId,
        'tjkId': this.tjkId,
        'providerId': this.providerId,
        'passState' : this.passState,
        'checkInTimes': this.checkInTimes,
        'checkInStartTime': this.checkInStartTime,
        'checkInEndTime': this.checkInEndTime
      }
      this.$http.post(API_ROOT.college + '/operatorEvaluation/queryOperatorEvaluations', data).then(response => {
        var result = response.data
        if(result.success) {
          this.success = result.success
          this.message = result.msg
          this.list = result.data.evaluationRecords
          this.examiningList = result.data.examiningList
        }else {
          this.$alert(result.msg)
        }
      }, response => {
        this.$alert('网络繁忙，请稍后重试！')
      })
    },
    //群考核
    checkGroup() {
      var self = this
      self.check.callOutPhone = ''
      self.check.averageDuration = ''

      var ids = []
      self.multipleSelection.map((item)=> {
        ids.push(item.recordId)
      })
      if(ids.length == 0) {
        self.$alert('请先选择淘金客')
        return false
      }
      this.$refs.check.open({
        title: '群考核',
        width: 800,
        callBack: function (arg) {
          if (arg.type === 'cancel') {
            arg.close()
            return
          }
          if(self.check.callPhone == '') {
            self.$alert('外呼电话不能为空')
            return false
          }
          if(self.check.averageDuration == '') {
            self.$alert('平均外呼时长不能为空')
            return false
          }
          var reg = /^[0-9]*[1-9][0-9]*$/
          if(!reg.test(self.check.callPhone) || !reg.test(self.check.averageDuration)) {
            self.$alert('只能填写正整数')
            return false
          }
          if (arg.pending()) return
          arg.pending(true)

          var data = {
            'groupId': self.groupId,
            'callPhone': self.check.callPhone,
            'averageDuration': self.check.averageDuration,
            'recordIds': ids
          }
          self.$http.post(API_ROOT.college + '/operatorExam/startOperatorExam', data, {headers: {'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'}}).then(response => {
            arg.pending(false)
            var result = response.data
            if(result.success) {
              self.$message({
                message: '已添加',
                type: 'success',
                center: true,
                duration: 1000
              })
              arg.close()
              window.location.href = '/tjkStudy/enterExam?id='+result.data.currentExamRecord.operatorExamId+'&groupId='+self.groupId+'&groupName='+self.groupName
            } else {
              self.$alert(result.msg)
            }
          }, response => {
            self.$alert('网络繁忙，请稍后重试！')
          })
        }
      })
    },
    //保存打分
    saveScore() {
      var self = this,
          ids = [],
          isOk = true, //表单是否校验通过
          reg = /^[1-9]\d*|0$/

      self.list.map((item)=> {
        if((!!item.score && !reg.test(item.score))) {
          self.$alert('分数只能是非负整数')
          isOk = false
          return false
        }
        if(!!item.remark && item.remark.length > 200) {
          self.$alert('备注不能超过200字')
          isOk = false
          return false
        }
      })
      self.list.map((item)=> {
        if(!!item.passState) {
          ids.push({
            'recordId': item.recordId,
            'passState': item.passState,
            'score': !!item.score ? item.score : 0,
            'remark': !!item.remark ? item.remark : ''
          })
        }
      })
      var data = {
        'groupId': self.groupId,
        'records': ids
      }
      if(isOk) {
        self.$http.post(API_ROOT.college + '/operatorEvaluation/batchScore', data).then(response => {
          var result = response.data
          if(result.success) {
            self.$message({
              message: '操作成功',
              type: 'success',
              center: true,
              duration: 1000
            })
            self.list = result.data.evaluationRecords
            self.examiningList = result.data.examiningList
          } else {
            self.$alert(result.msg)
            self.getList()
          }
        }, response => {
          self.$alert('网络繁忙，请稍后重试！')
        })
      }
    },
    //发布成绩
    releaseGroup() {
      var self = this
      //筛选状态有值的淘金客
      var ids = []
      if(self.multipleSelection.length > 0) {
        self.multipleSelection.map((item)=> {
          ids.push({
            'recordId': item.recordId,
            'tjkId': item.tjkId,
            'providerId': item.providerId,
            'passState': item.passState,
            'score': item.score,
            'remark': item.remark
          })
        })
      }
      var data = {
        'groupId': self.groupId,
        'records': ids
      }
      self.$confirm('确定发布成绩？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        self.$http.post(API_ROOT.college + '/operatorEvaluation/publishOperatorEvaluations', data).then(response => {
          var result = response.data
          if(result.success) {
            self.$message({
              message: '已发布',
              type: 'success',
              center: true,
              duration: 1000
            })
            self.list = result.data.evaluationRecords
            self.examiningList = result.data.examiningList
          }else {
            self.$alert(result.msg)
            self.getList()
          }
        }, response => {
          self.$alert('网络繁忙，请稍后重试！')
        })
      }).catch(() => {
                 
      })
    },
    //结束培训
    endOperatorExam() {
      var self = this,
          data = {
            'groupId': this.groupId
          }
      self.$confirm('结束后将会解散群，确定结束培训？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        self.$http.post(API_ROOT.college + '/operatorEvaluation/endOperatorEvaluation', data).then(response => {
          var result = response.data
          if(result.success) {
            window.close()
          }else {
            self.$alert(result.msg)
          }
        }, response => {
          self.$alert('网络繁忙，请稍后重试！')
        })
      }).catch(() => {
                 
      })
    },
    //导出
    getExcel() {
      var arr = document.cookie.match(new RegExp('(^| )login_token=([^;]*)(;|$)'))
      var login_token = (arr != null) ? unescape(arr[2]) : null

      var url = API_ROOT.college + '/operatorEvaluation/exportOperatorExamEvaluations?tjk_login_token=' + login_token + '&groupId=' + this.groupId + '&tjkId=' + this.tjkId + '&providerId=' + this.providerId
      window.open(url)
    },
    //当选择项发生变化时会触发该事件
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    //淘金客自动搜索
    updateTjkId(val) {
      this.tjkId = val
    },
    //合作公司自动搜索
    updateProviderId(val) {
      this.providerId = val
    },
    //开始时间
    changeHandlerStart(val) {
      this.checkInStartTime = val
    },
    //结束时间
    changeHandlerEnd(val) {
      this.checkInEndTime = val
    }
  }
}
</script>
<style type="less" scoped>
.nuv {
  font-size: 16px;
}
.top-button {
  margin: 10px 15px 20px 0;
  display: inline-block;
}
.tab > li {
  float: left;
  padding: 10px;
  margin-bottom: 20px;
  background-color: #ffffff;
  border: 1px solid #dfdfdf;
  margin-right: 10px;
  border-radius: 4px;
  -webkit-border-radius: 4px;
  -moz-border-radius: 4px;
}
.tab > li.active {
  background-color: #ecf5ff;
  border: 1px solid #b3d8ff;
  color: #ffffff;
  cursor: pointer;
}
.tab > li.active:hover {
  background-color: #409EFF;
}
.tab > li.active:hover > a {
  color: #ffffff;
}
.tip-box {
  display: inline-block;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  border: 1px solid #80a9f5;
  text-align: center;
  margin-right: 20px;
}
.tip-con {
  font-size: 14px;
  line-height: 24px;
}
</style>


// WEBPACK FOOTER //
// ./src/page/provider/operatorExamine.vue